export const COMMON_FETCH_EVENTS = {
  START: 'START_COMMON_FETCH_EVENTS',
  COMPLETE: 'COMPLETE_COMMON_FETCH_EVENTS',
  FAIL: 'FAIL_COMMON_FETCH_EVENTS',
  CLEANUP: 'CLEANUP_COMMON_FETCH_EVENTS',
}

export const COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES = {
  START: 'START_COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES',
  COMPLETE: 'COMPLETE_COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES',
  FAIL: 'FAIL_COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES',
  CLEANUP: 'CLEANUP_COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES',
}
